exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-block7[data-v-73f79576]{background:#fff}.linebanner img[data-v-73f79576]{width:80%;padding:64px 0}.box[data-v-73f79576]{padding:0 10px}.box img[data-v-73f79576]{width:100%}.infotitle-min[data-v-73f79576]{font-size:14px;color:#000;margin:0;margin-top:24px}.infotitle[data-v-73f79576]{font-size:19px;color:#000;margin:1px;margin-bottom:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73f79576","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/MarkLp/Kurenotori/Lp1/LpBlock7.vue
// module id = qiqM
// module chunks = 0